export const PATCH_HISTORY = [
  {
    date: "26.07.01",
    version: "11.6",
    changes: [
      { text: "에키온 / VF 의수" },
      { text: "VF 의수" },
      { type: "buff", before: "57", after: "60", text: "데스애더퀸 공격력 57 → 60" },
      { type: "buff", before: "49", after: "52", text: "블랙맘바킹 공격력 49 → 52" },
      { type: "buff", before: "63", after: "66", text: "데스애더퀸-MT 공격력 63 → 66" },
      { type: "buff", before: "70", after: "72", text: "데스애더퀸-FC 공격력 70 → 72" },
      { type: "buff", before: "49", after: "52", text: "블랙맘바킹-TL 공격력 49 → 52" },
      { type: "buff", before: "62", after: "65", text: "블랙맘바킹-FC 공격력 62 → 65" },
      { type: "buff", before: "75", after: "78", text: "데스애더퀸-VBS 공격력 75 → 78" },
      { type: "buff", before: "66", after: "69", text: "블랙맘바킹-VBS 공격력 66 → 69" },
    ],
  },
  {
    date: "26.06.01",
    version: "11.5",
    changes: [
      { text: "VF폭주(R)" },
      {
        type: "buff",
        before: "12%",
        after: "14%",
        text: "독사의 진노[블랙 맘바] 피해량 50/120/175/220(+공격력의 80%)(+추가 체력의 12%) → 50/120/175/220(+공격력의 80%)(+추가 체력의 14%)",
      },
    ],
  },
  {
    date: "26.04.01",
    version: "10.6",
    changes: [
      { type: "nerf", before: "39", after: "35", text: "기본 공격력 39 → 35" },
      { text: "VF 폭주(R)" },
      {
        type: "buff",
        before: "10%",
        after: "12%",
        text: "독사의 진노[블랙맘바] 피해량 50/120/175/220(+공격력의 80%)(+추가 체력의 10%) → 50/120/175/220(+공격력의 80%)(+추가 체력의 12%)",
      },
    ],
  },
  {
    date: "26.03.19",
    version: "10.5",
    changes: [
      { text: "VF의수" },
      { text: "블랙맘바킹" },
      { type: "buff", text: "불꽃 결계 - [고유 장착 효과] (신규)" },
      {
        type: "buff",
        text: "VF폭주 상태일 때 전투에 돌입하면 매 초마다 주변 2.5m의 적에게 스킬 피해를 입힙니다. 적에게 최대 체력의 2%의 스킬 피해를 입힙니다.",
      },
      {
        type: "buff",
        text: "VF폭주 상태일 때에는 블랙맘바킹의 불꽃 결계만 발동합니다.",
      },
    ],
  },
  {
    date: "25.10.30",
    version: "9.2",
    changes: [
      {
        text: "에키온은 모든 무기 군이 평균 이상의 지표를 기록하고 있습니다. 기본 공격력을 낮춰 전반적인 위력을 하향 조정합니다.",
      },
      { type: "nerf", before: "42", after: "39", text: "기본 공격력 42 → 39" },
    ],
  },
  {
    date: "25.10.01",
    version: "8.7",
    changes: [
      {
        text: "높은 내구도를 보이고 있는 에키온의 기본 체력을 낮춥니다. 특히 높은 지표를 기록하고 있는 사이드와인더 무기군은 VF 의수의 공격력을 감소시켜 추가로 위력을 하향 조정합니다.",
      },
      { type: "nerf", before: "990", after: "955", text: "기본 체력 990 → 955" },
      { text: "VF 의수" },
      {
        type: "nerf",
        before: "70",
        after: "68",
        text: "슈퍼사이드와인더 공격력 70 → 68",
      },
      {
        type: "nerf",
        before: "76",
        after: "74",
        text: "슈퍼사이드와인더-ML 공격력 76 → 74",
      },
    ],
  },
  {
    date: "",
    version: "8.3b",
    changes: [
      { text: "에키온" },
      { text: "독사의 칼날(Q)" },
      {
        type: "nerf",
        before: "40/65/90/115/140(+공격력의 65%)",
        after: "40/60/80/100/120(+공격력의 65%)",
        text: "2타 피해량 40/65/90/115/140(+공격력의 65%) → 40/60/80/100/120(+공격력의 65%)",
      },
    ],
  },
  {
    date: "25.08.07",
    version: "8.3",
    changes: [
      {
        text: "에키온이 VF 폭주 상태에서도 W - 뒤집힌 비늘을 사용할 수 있게 되면서, 해당 스킬의 쿨다운 감소 효과를 보유한 사이드와인더 에키온의 전투 지속력이 과도하게 상승하였습니다. 사이드와인더 에키온의 내구도를 조정하기 위해, 해당 쿨다운 감소 수치를 하향합니다.",
      },
      {
        text: "또한, 사이드와인더의 R2 - 독사의 진노 피해량 계수를 추가 공격력 기반으로 변경하여, 방어적인 세팅을 선택했을 때는 충분한 피해를 기대하기 어렵도록 조정합니다.",
      },
      { text: "카드모스의 부름(P)" },
      { text: "사이드와인더" },
      {
        type: "nerf",
        before: "30%",
        after: "15%",
        text: "뒤집힌 비늘(W) 쿨다운 감소 30% → 15%",
      },
      { text: "VF폭주(R)" },
      {
        type: "nerf",
        before: "80/150/190/230(+공격력의 110%)",
        after: "40/80/125/170(+추가 공격력의 200%)",
        text: "독사의 진노(R2) 사이드와인더 피해량 80/150/190/230(+공격력의 110%) → 40/80/125/170(+추가 공격력의 200%)",
      },
    ],
  },
  {
    date: "25.07.24",
    version: "8.2",
    changes: [
      {
        text: "에키온은 뛰어난 내구도와 진입 능력을 바탕으로 최상위권 실력대 게임에서 우수한 성능을 보이고 있습니다. 레벨 당 방어력을 하향 조정하여 기본 내구도를 낮추고, 특히 강한 성능을 보이는 사이드와인더 및 블랙맘바 무기군은 R2 - 독사의 진노의 피해량을 감소시켜 위력을 견제합니다. 반면, 상대적으로 낮은 성능을 보이고 있는 데스애더 무기군은 VF 의수 아이템을 상향 조정하여 보완합니다.",
      },
      { type: "nerf", before: "3.4", after: "3.2", text: "레벨 당 방어력 3.4 → 3.2" },
      { text: "VF폭주(R)" },
      {
        type: "nerf",
        before: "50/140/195/240(+공격력의 80%)(+추가 체력의 10%)",
        after: "50/120/175/220(+공격력의 80%)(+추가 체력의 10%)",
        text: "블랙맘바 독사의 진노(R2) 피해량 50/140/195/240(+공격력의 80%)(+추가 체력의 10%) → 50/120/175/220(+공격력의 80%)(+추가 체력의 10%)",
      },
      {
        type: "nerf",
        before: "80/180/220/260(+공격력 100%)",
        after: "80/150/190/230(+공격력 110%)",
        text: "사이드와인더 독사의 진노(R2) 피해량 80/180/220/260(+공격력 100%) → 80/150/190/230(+공격력 110%)",
      },
    ],
  },
  {
    date: "25.07.17",
    version: "8.1",
    changes: [
      {
        text: "에키온은 지난 패치에서 VF 폭주 상태에서도 기본 스킬을 사용할 수 있게 변경되면서, 높은 위력을 보여주고 있습니다. 기본 능력치와 W - 뒤집힌 비늘의 보호막량을 감소시켜 전반적인 내구도를 낮추고, 특히 강한 성능을 보이는 사이드와인더와 블랙맘바 무기군의 스킬 피해량을 추가로 조정하여 위력을 견제합니다.",
      },
      { type: "nerf", before: "94", after: "92", text: "레벨 당 체력 94 → 92" },
      { text: "뒤집힌 비늘(W)" },
      {
        type: "nerf",
        before: "20/40/60/80/100(+공격력의 60%)",
        after: "20/40/60/80/100(+공격력의 50%)",
        text: "보호막량 20/40/60/80/100(+공격력의 60%) → 20/40/60/80/100(+공격력의 50%)",
      },
      { text: "VF폭주(R)" },
      {
        type: "nerf",
        before: "30/40/50/60%",
        after: "20/30/40/50%",
        text: "사이드와인더 스킬 공격 추가 피해 30/40/50/60% → 20/30/40/50%",
      },
      {
        type: "nerf",
        before: "50/140/195/250(+공격력의 80%)(+추가 체력의 12%)",
        after: "50/140/195/250(+공격력의 80%)(+추가 체력의 10%)",
        text: "독사의 진노(R2) 블랙맘바 피해량 50/140/195/250(+공격력의 80%)(+추가 체력의 12%) → 50/140/195/250(+공격력의 80%)(+추가 체력의 10%)",
      },
    ],
  },
  {
    date: "",
    version: "8.0c",
    changes: [
      { text: "에키온" },
      { type: "nerf", before: "96", after: "94", text: "레벨 당 체력 96 → 94" },
      { text: "VF폭주(R)" },
      {
        type: "nerf",
        before: "0.4/0.6/0.8/1%",
        after: "0.3/0.5/0.7/0.9%",
        text: "VF 게이지 비례 피해 증가량 0.4/0.6/0.8/1% → 0.3/0.5/0.7/0.9%",
      },
    ],
  },
  {
    date: "25.07.10",
    version: "8.0",
    changes: [
      {
        text: "에키온은 그간 R - VF 폭주 상태에서 Q - 독사의 칼날과 W - 뒤집힌 비늘을 사용할 수 없어 스킬 운용의 난이도가 높았습니다. 하지만 이제 VF 폭주 상태에서도 스킬을 사용할 수 있도록 변경되어 보다 유연한 전투 운용이 가능해집니다. 다만, 폭주 중 스킬 사용이 가능해진 만큼 기본 능력치와 일부 스킬의 성능은 조정됩니다.",
      },
      { type: "nerf", before: "54", after: "50", text: "기본 방어력 54 → 50" },
      { type: "nerf", before: "3.6", after: "3.4", text: "레벨 당 방어력 3.6 → 3.4" },
      { text: "카드모스의 부름(P)" },
      { text: "사이드와인더" },
      {
        type: "nerf",
        before: "40/50/60/70%",
        after: "30/40/50/60%",
        text: "스킬 추가 피해 40/50/60/70% → 30/40/50/60%",
      },
      {
        type: "nerf",
        before: "40%",
        after: "30%",
        text: "뒤집힌 비늘(W) 쿨다운 감소 40% → 30%",
      },
      { text: "독사의 칼날 (Q)" },
      { type: "nerf", before: "5초", after: "6초", text: "쿨다운 5초 → 6초" },
      {
        type: "buff",
        before: "20/45/70/95/120(+공격력의 70%)",
        after: "40/65/90/115/140(+공격력의 65%)",
        text: "2타 피해량 20/45/70/95/120(+공격력의 70%) → 40/65/90/115/140(+공격력의 65%)",
      },
      {
        type: "nerf",
        before: "10/15/20/25/30%",
        after: "5/10/15/20/25%",
        text: "2타 적중 시 이동 속도 감소 10/15/20/25/30% → 5/10/15/20/25%",
      },
      { text: "뒤집힌 비늘(W)" },
      {
        type: "nerf",
        before: "9/8.5/8/7.5/7초",
        after: "10/9.5/9/8.5/8초",
        text: "쿨다운 9/8.5/8/7.5/7초 → 10/9.5/9/8.5/8초",
      },
      {
        type: "buff",
        before: "40/55/70/85/100(+공격력의 20%)",
        after: "20/40/60/80/100(+공격력의 60%)",
        text: "보호막량 40/55/70/85/100(+공격력의 20%) → 20/40/60/80/100(+공격력의 60%)",
      },
      {
        type: "nerf",
        before: "400%",
        after: "200%",
        text: "추가 보호막량 소모한 VF 게이지의 400% → 200%",
      },
      { text: "VF폭주(R)" },
      { type: "buff", text: "에키온이 VF폭주 상태일 때 독사의 칼날(Q), 뒤집힌 비늘(W) 사용 불가 (삭제)" },
      { type: "buff", text: "VF폭주 상태일 때 독사의 칼날(Q), 메마른 송곳니(E)의 VF게이지 비례 피해량 최대치로 적용 (신규)" },
      { type: "buff", text: "VF폭주 상태일 때 뒤집힌 비늘(W) VF게이지 소모량 비례 보호막량 최대치로 적용 (신규)" },
      {
        type: "nerf",
        before: "0.6/0.9/1.2/1.5%",
        after: "0.4/0.6/0.8/1%",
        text: "VF게이지 1 당 스킬 피해량 증가 0.6/0.9/1.2/1.5% → 0.4/0.6/0.8/1%",
      },
      {
        type: "nerf",
        before: "8/12/16/20(+공격력의 8%)",
        after: "7/10/13/16(+공격력의 7%)",
        text: "주변 고정 피해량 8/12/16/20(+공격력의 8%) → 7/10/13/16(+공격력의 7%)",
      },
      {
        type: "nerf",
        before: "20/25/30/35%",
        after: "15/20/25/30%",
        text: "블랙맘바 스킬 피해 흡혈 20/25/30/35% → 15/20/25/30%",
      },
      {
        type: "nerf",
        before: "60/150/205/260(+공격력의 90%)(+추가 체력의 12%)",
        after: "50/140/195/250(+공격력의 80%)(+추가 체력의 12%)",
        text: "블랙맘바 독사의 진노(R2) 피해량 60/150/205/260(+공격력의 90%)(+추가 체력의 12%) → 50/140/195/250(+공격력의 80%)(+추가 체력의 12%)",
      },
      {
        type: "nerf",
        before: "95/200/240/280(+공격력의 110%)",
        after: "80/180/220/260(+공격력의 100%)",
        text: "사이드 와인더 독사의 진노(R2) 피해량 95/200/240/280(+공격력의 110%) → 80/180/220/260(+공격력의 100%)",
      },
    ],
  },
  {
    date: "25.05.15",
    version: "1.47",
    changes: [
      {
        text: "에키온은 R - VF 폭주를 통해 전장을 휘젓는 실험체이지만, 폭주 종료 시 생기는 과부하 시간과 VF 게이지를 채우는 시간이 오래 걸려 다시금 폭주하여 교전에 재진입하는 데에 어려움을 겪는 편입니다. 에키온의 과부하 시간을 줄이고 VF 게이지를 좀 더 빨리 얻게 하여 폭주가 끝난 후에도 좀 더 빠르게 교전에 복귀할 수 있도록 합니다. 또한, W - 뒤집힌 바늘의 쿨다운을 줄여서 VF 게이지를 좀 더 용이하게 활용할 수 있도록 합니다.",
      },
      { text: "독사의 칼날(Q)" },
      {
        type: "buff",
        before: "10/11/12/13/14",
        after: "12/13/14/15/16",
        text: "적중 시 VF 게이지 증가량 10/11/12/13/14 → 12/13/14/15/16",
      },
      {
        type: "buff",
        before: "14/16/18/20/22",
        after: "16/18/20/22/24",
        text: "재사용 적중 시 VF 게이지 증가량 14/16/18/20/22 → 16/18/20/22/24",
      },
      { text: "뒤집힌 비늘(W)" },
      {
        type: "nerf",
        before: "50/65/80/95/110(+공격력의 20%)",
        after: "40/55/70/85/100(+공격력의 20%)",
        text: "보호막 흡수량 50/65/80/95/110(+공격력의 20%) → 40/55/70/85/100(+공격력의 20%)",
      },
      {
        type: "buff",
        before: "10/9.5/9/8.5/8초",
        after: "9/8.5/8/7.5/7초",
        text: "쿨다운 10/9.5/9/8.5/8초 → 9/8.5/8/7.5/7초",
      },
      { text: "메마른 송곳니(E)" },
      {
        type: "buff",
        before: "15/16/17/18/19",
        after: "16/17/18/19/20",
        text: "적중 시 VF 게이지 증가량 15/16/17/18/19 → 16/17/18/19/20",
      },
      { text: "VF폭주(R)" },
      { type: "buff", before: "10초", after: "8초", text: "과부하 지속 시간 10초 → 8초" },
    ],
  },
  {
    date: "25.04.30",
    version: "1.46",
    changes: [
      {
        text: "에키온의 R - 독사의 진노가 무기 별로 보다 강력한 피해를 발휘할 수 있도록 전반적인 위력을 올립니다.",
      },
      { text: "독사의 진노(R)" },
      { text: "데스애더" },
      {
        type: "buff",
        before: "90/180/225/270(+공격력의 85/100%)",
        after: "90/200/250/300(+공격력의 90/110%)",
        text: "피해량 90/180/225/270(+공격력의 85/100%) → 90/200/250/300(+공격력의 90/110%)",
      },
      { text: "블랙맘바" },
      {
        type: "buff",
        before: "60/150/205/260(+공격력의 80/90%)(+추가 체력의 10%)",
        after: "60/150/205/260(+공격력의 80/90%)(+추가 체력의 12%)",
        text: "피해량 60/150/205/260(+공격력의 80/90%)(+추가 체력의 10%) → 60/150/205/260(+공격력의 80/90%)(+추가 체력의 12%)",
      },
      { text: "사이드와인더" },
      {
        type: "buff",
        before: "95/190/230/270(+공격력의 85/105%)",
        after: "95/200/240/280(+공격력의 90/110%)",
        text: "피해량 95/190/230/270(+공격력의 85/105%) → 95/200/240/280(+공격력의 90/110%)",
      },
    ],
  },
  {
    date: "25.04.17",
    version: "1.45",
    changes: [
      { type: "buff", before: "3.4", after: "3.6", text: "레벨 당 방어력 3.4 → 3.6" },
      { text: "VF폭주(R)" },
      {
        type: "buff",
        before: "35%",
        after: "40%",
        text: "[데스애더] 기본 공격 추가 피해 공격력의 35%*(기본 공격 증폭) → 40%*(기본 공격 증폭)",
      },
      {
        type: "buff",
        before: "35/45/55/65%",
        after: "40/50/60/70%",
        text: "[사이드와인더] 스킬 공격 추가 피해량 35/45/55/65% → 40/50/60/70%",
      },
      { type: "buff", before: "12초", after: "10초", text: "과부하 지속 시간 12초 → 10초" },
    ],
  },
  {
    date: "25.04.03",
    version: "1.44",
    changes: [
      { text: "에키온의 레벨이 높아질수록 조금 더 단단해질 수 있도록 합니다." },
      { type: "buff", before: "3.2", after: "3.4", text: "레벨 당 방어력 3.2 → 3.4" },
    ],
  },
  {
    date: "25.03.27",
    version: "1.43.1",
    changes: [
      { text: "주력 아이템들의 변경으로, 약한 모습을 보이고 있는 사이드와인더의 위력을 올립니다." },
      { text: "카드모스의 부름(P)" },
      {
        type: "buff",
        before: "30/40/50/60%",
        after: "35/45/55/65%",
        text: "사이드와인더 추가 스킬 피해량 30/40/50/60% → 35/45/55/65%",
      },
    ],
  },
  {
    date: "25.02.20",
    version: "1.41",
    changes: [
      {
        text: "Q - 독사의 칼날 1타 적중 난이도를 완화하고, 적중 시 재사용 가능 시간을 조금 더 주어 스킬 활용 여지를 늘립니다.",
      },
      { text: "독사의 칼날(Q)" },
      { type: "buff", before: "2초", after: "3초", text: "적중 시 재사용 가능 시간 2초 → 3초" },
      {
        type: "buff",
        before: "16.3m/s",
        after: "17m/s",
        text: "첫 번째 사용 시(Q1) 투사체 속도 16.3m/s → 17m/s",
      },
    ],
  },
  {
    date: "25.01.16",
    version: "1.39",
    changes: [
      { type: "nerf", before: "3.5", after: "3.2", text: "레벨 당 방어력 3.5 → 3.2" },
      { text: "카드모스의 부름(P)" },
      {
        type: "nerf",
        before: "25/30/35/40%",
        after: "20/25/30/35%",
        text: "[블랙맘바] 스킬로 피해를 입혔을 때 체력 회복량 피해량의 25/30/35/40% → 20/25/30/35%",
      },
    ],
  },
];
